import React, {
  useState,
  useCallback,
  useReducer,
  useRef,
} from "react";
import { useTranslation } from "react-i18next";
import { AutocompleteComponent } from "../../../../../../../Components";
import { AgentRoleEnum, AgentTypesEnum } from "../../../../../../../Enums";
import { OrganizationUserSearch } from "../../../../../../../Services";


export const AgentsSection = ({
  isReadOnly,
  selected,
  onSelectedChanged,
  parentTranslationPath,
  translationPath,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const searchTimer = useRef(null);

  const reducer = useCallback((state, action) => {
    if (action.id !== "edit") return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);
  const [isFieldShown, setIsFieldShown] = useState({
    otherTenantAgents: false,
    otherLandlordAgents: false,
  });
  const [data, setData] = useReducer(reducer, {
    systemUsers: {
      landlordAgents: [],
      tenantAgents: [],
    },
  });

  const getSystemUsers = async (userType, searchedItem) => {
    const res = await OrganizationUserSearch({
      pageIndex: 0,
      pageSize: 10,
      userTypeId: AgentRoleEnum.LeaseAgent.value,
      name: searchedItem || "",
      userStatusId: 2,
    });
    if (!(res && res.status && res.status !== 200))
      setData({
        id: "systemUsers",
        value: {
          ...(data.systemUsers || []),
          [userType]: res?.result,
        },
      });
    else setData({ id: "systemUsers", value: [] });
  };

  

  return (
    <>
      <div className="d-flex fj-start b-bottom">
        <div className="w-33 mt-2 pt-1">
          <span className="fw-simi-bold">{t(`${translationPath}Tenant-agent`)}</span>
        </div>
        <div className="w-50 mt-2 mb-3 pt-1">
          <div className="d-flex-column gap-12">
            <AutocompleteComponent
              idRef="tenant-agentIdRef"
              inputPlaceholder="select"
              selectedValues={selected.tenantAgent}
              multiple={false}
              data={data.systemUsers?.tenantAgents || []}
              displayLabel={(option) => option.fullName || ""}
              renderOption={(option) =>
                ((option.userName || option.fullName) &&
                  `${option.fullName} (${option.userName})`) ||
                ""
              }
              withoutSearchButton
              onOpen={() => {
                const userType = "tenantAgents";
                if (
                  data.systemUsers?.tenantAgents &&
                  data.systemUsers.tenantAgents.length == 0
                )
                  getSystemUsers(userType);
              }}
              onInputKeyUp={(e) => {
                const { value } = e.target;
                const userType = "tenantAgents";

                if (searchTimer) clearTimeout(searchTimer.current);

                searchTimer.current = setTimeout(() => {
                  getSystemUsers(userType, value);
                }, 1200);
              }}
              isWithError
              // isSubmitted={isSubmitted}
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              onChange={(_, newValue) => {
                let newSelected = [];
                let newTenantAgent =
                  (newValue && {
                    id: newValue.id,
                    fullName: newValue.fullName,
                    isOriginalAgent: true,
                    agentType: AgentTypesEnum.Tenant.value,
                  }) ||
                  null;

                if (newTenantAgent && !selected.otherTenantAgents) {
                  newSelected.push(newTenantAgent);
                }
                if (
                  newTenantAgent &&
                  !selected.tenantAgent &&
                  selected.otherTenantAgents
                ) {
                  newSelected = [newTenantAgent, ...selected.agents];
                }
                if (
                  newTenantAgent &&
                  selected.tenantAgent &&
                  selected.otherTenantAgents
                ) {
                  const agentsList = [...selected.agents];
                  agentsList.shift();
                  newSelected = [newTenantAgent, ...agentsList];
                }
                if (
                  !newTenantAgent &&
                  selected.tenantAgent &&
                  selected.otherTenantAgents
                ) {
                  const agentsList = [...selected.agents];
                  agentsList.shift();
                  newSelected = agentsList;
                }
                if (newSelected.length > 0)
                  onSelectedChanged({ id: "agents", value: newSelected });
                // onStateChange({ id: 'agents', value: mappedStateAgents });
                else onSelectedChanged({ id: "agents", value: [] });
                // onStateChange({ id: 'agents', value: null });

                onSelectedChanged({ id: "tenantAgent", value: newTenantAgent });
                // onStateChange({ id: 'tenantAgent', value: mappedTenantAgent });
              }}
              isDisabled
              //isDisabled={isReadOnly}

            />
          </div>
        </div>
      </div>
      <div className="d-flex fj-start b-bottom">
        <div className="w-33 mt-2 pt-1">
          <p className="fw-simi-bold m-0">{t(`${translationPath}Landlord-agent`)}</p>
          <p className="light-text">{t(`${translationPath}Listing-agent`)}</p>
        </div>
        <div className="w-50 mt-2 mb-3 pt-1">
          <div className="d-flex-column gap-12">
            <AutocompleteComponent
              idRef="landlord-agentRef"
              inputPlaceholder="select"
              selectedValues={selected.landlordAgent}
              multiple={false}
              data={data.systemUsers?.landlordAgents || []}
              displayLabel={(option) => option.fullName || ""}
              renderOption={(option) =>
                ((option.userName || option.fullName) &&
                  `${option.fullName} (${option.userName})`) ||
                ""
              }
              isDisabled={
                (selected.unitHasListingAgents && !isReadOnly) || isReadOnly
              }
              withoutSearchButton
              onOpen={() => {
                const userType = "landlordAgents";
                if (
                  data.systemUsers?.landlordAgents &&
                  data.systemUsers.landlordAgents.length == 0
                )
                  getSystemUsers(userType);
              }}
              onInputKeyUp={(e) => {
                const { value } = e.target;
                const userType = "landlordAgents";

                if (searchTimer) clearTimeout(searchTimer.current);

                searchTimer.current = setTimeout(() => {
                  getSystemUsers(userType, value);
                }, 1200);
              }}
              isWithError
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              onChange={(_, newValue) => {
                let newSelected = [];
                let newLandlordAgent =
                  (newValue && {
                    id: newValue.id,
                    fullName: newValue.fullName,
                    isListingAgent: true,
                    listingAgentType: AgentTypesEnum.Landlord.value,
                  }) ||
                  null;

                if (newLandlordAgent && !selected.otherLandlordAgents) {
                  newSelected.push(newLandlordAgent);
                }
                if (
                  newLandlordAgent &&
                  !selected.landlordAgent &&
                  selected.otherLandlordAgents
                ) {
                  newSelected = [newLandlordAgent, ...selected.listingAgents];
                }
                if (
                  newLandlordAgent &&
                  selected.landlordAgent &&
                  selected.otherLandlordAgents
                ) {
                  const agentsList = [...selected.listingAgents];
                  agentsList.shift();
                  newSelected = [newLandlordAgent, ...agentsList];
                }
                if (
                  !newLandlordAgent &&
                  selected.landlordAgent &&
                  selected.otherLandlordAgents
                ) {
                  const agentsList = [...selected.listingAgents];
                  agentsList.shift();
                  newSelected = agentsList;
                }
                if (newSelected.length > 0)
                  onSelectedChanged({ id: "listingAgents", value: newSelected });
                else onSelectedChanged({ id: "listingAgents", value: [] });
                onSelectedChanged({
                  id: "landlordAgent",
                  value: newLandlordAgent,
                });
              }}
            />
            {!isFieldShown.otherLandlordAgents && (
              <span
                className="d-flex fw-simi-bold pointer "
                onClick={() =>
                  setIsFieldShown((prevState) => ({
                    ...prevState,
                    otherLandlordAgents: true,
                  }))
                }
              >
                <span className="icons b-icon i-plus i-20 mb-1 mr-1"></span>
                <span className="fz-14 light-text">
                  {t(`${translationPath}Add-another`)}
                </span>
              </span>
            )}

            {isFieldShown.otherLandlordAgents && (
              <AutocompleteComponent
                idRef="other-landlord-agentsIdRef"
                labelValue="other-landlord-agents"
                labelClasses="px-0"
                inputPlaceholder="select"
                selectedValues={selected.otherLandlordAgents || []}
                multiple
                data={data.systemUsers?.landlordAgents || []}
                displayLabel={(option) => option.fullName || ""}
                chipsLabel={(option) => option.fullName || ""}
                renderOption={(option) =>
                  ((option.userName || option.fullName) &&
                    `${option.fullName} (${option.userName})`) ||
                  ""
                }
                // getOptionSelected={(option) => selected.otherLandlordAgents && selected.otherLandlordAgents.findIndex((item) => item.id === option.id) !== -1 || ''}
                withoutSearchButton
                // isLoading={loadings.agents}
                onOpen={() => {
                  const userType = "landlordAgents";
                  if (
                    data.systemUsers?.landlordAgents &&
                    data.systemUsers.landlordAgents.length == 0
                  )
                    getSystemUsers(userType);
                }}
                onInputKeyUp={(e) => {
                  const { value } = e.target;
                  const userType = "landlordAgents";

                  if (searchTimer) clearTimeout(searchTimer.current);

                  searchTimer.current = setTimeout(() => {
                    getSystemUsers(userType, value);
                  }, 1200);
                }}
                // isSubmitted={isSubmitted}
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
                onChange={(_, newValue) => {
                  let newSelected = [];
                  let newOtherLandlordAgents = newValue.map((item) => ({
                    id: item.id,
                    fullName: item.fullName,
                    isListingAgent: false,
                    listingAgentType: AgentTypesEnum.Landlord.value,
                  }));
                  if (!selected.landlordAgent) {
                    newSelected = newOtherLandlordAgents;
                  } else {
                    newSelected = [
                      selected.landlordAgent,
                      ...newOtherLandlordAgents,
                    ];
                  }

                  if (newSelected.length > 0) {
                    // onStateChange({ id: 'listingAgents', value: mappedStateAgents });
                    onSelectedChanged({
                      id: "listingAgents",
                      value: newSelected,
                    });
                    onSelectedChanged({
                      id: "otherLandlordAgents",
                      value: newOtherLandlordAgents,
                    });
                  } else {
                    onSelectedChanged({ id: "listingAgents", value: [] });
                    // onStateChange({ id: 'listingAgents', value: null });
                    onSelectedChanged({
                      id: "otherLandlordAgents",
                      value: null,
                    });
                  }
                }}
                isDisabled={isReadOnly}
                chipsDisabled={()=> isReadOnly}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

